module.exports = __webpack_public_path__ + "static/media/star.22028ad4.png";